import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 0),
  backgroundColor: '#f9fafb',
  textAlign: 'left',
}));

const SectionTitle = styled(Typography)({
  textAlign: 'center',
  marginBottom: '40px',
});

const FAQItem = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const FAQ = () => {
  return (
    <Root>
      <Container>
        <SectionTitle variant="h3" gutterBottom>
          FAQ
        </SectionTitle>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FAQItem>
              <Typography variant="h5" gutterBottom>
                Jak zacząć?
              </Typography>
              <Typography variant="body2">
                Aby rozpocząć, kliknij przycisk "Rozpocznij teraz" na górze strony.
              </Typography>
            </FAQItem>
          </Grid>
          <Grid item xs={12} md={6}>
            <FAQItem>
              <Typography variant="h5" gutterBottom>
                Czy aplikacja jest darmowa?
              </Typography>
              <Typography variant="body2">
                Tak, aplikacja jest całkowicie darmowa.
              </Typography>
            </FAQItem>
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

export default FAQ;
